/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Tag } from '../models/Tag';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanyJobTagService {

    /**
     * Returns the list of company job tags
     * @returns any Success
     * @throws ApiError
     */
    public static getCompanyJobTagList(): CancelablePromise<{
        rows?: Array<Tag>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobdata/tag',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Add tags to companyJobs
     * @returns Tag Success
     * @throws ApiError
     */
    public static assignCompanyJobTags({
        requestBody,
    }: {
        requestBody: {
            tags: any[];
            companyJobIds: any[];
            replace?: boolean;
        },
    }): CancelablePromise<Array<Tag>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobdata/tag',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
